import validator from './validator';
import cookie from './cookie';


var signup = function()
{
  let publisher = document.querySelector('.js--checkbox-publisher');

  if(!publisher) return;
  let publisherInput = publisher.querySelector('input');
  let publisherSug = publisher.querySelector('.checkbox--publisher');



  publisherInput.addEventListener('change', function(){
    if(this.checked) {
      publisherSug.style.display='flex';
      publisherSug.querySelector('input').required = true;
    } else {
      publisherSug.style.display='';
      publisherSug.querySelector('input').required = false;
    }
  })

  if(cookie.get('redirect_to') == 'advertiser/dashboard') {
    let el = document.querySelector('input[value="advertiser"]');
    el.checked = true;
    el.disabled = true;

    let item = document.createElement('input');
    item.value = 'advertiser';
    item.name = 'types[]';
    item.style.display = 'none';

    document.querySelector('.form--signup').appendChild(item)

  }




var pattern = {
  password: {
    regexp: {
      regexp: /(?=.*\d)(?=.*[a-zA-Z]).*/,
      message: 'Password should include numbers and letters'
    },
  },
  firstname: {
    regexp: {
      regexp: /^[a-zA-Zа-яА-Я0-9]+$/,
      message: 'The firstname can only consist of alphabetical and number'
    }
  },
  lastname: {
    regexp: {
      regexp: /^[a-zA-Zа-яА-Я0-9]+$/,
      message: 'The lastname can only consist of alphabetical and number'
    }
  },
  password_confirmation: {
    compare: {
      field: 'password',
      message: 'The password and its confirm are not the same'
    }
  },
  'types[]': {
    requiredAll: {
      message: 'Account Type is required'
    }
  }
}
validator('.form--signup', pattern);








}

export default signup();
